import { ChangeDetectorRef } from '@angular/core';

export class TemporalState<T> {

  private enterStateTimer: any;
  private leaveStateTimer: any;

  private _currentState: T;

  private get currentState(): T {
    return this._currentState;
  }

  private set currentState(
    value: T
  ) {
    this._currentState = value;
    this.changeDetector && this.changeDetector.detectChanges();
  }

  constructor(
    private readonly leaveDelayInMs: number,
    private readonly enterDelayInMs: number,
    private readonly leaveState: T,
    private readonly enterState: T,
    private readonly initialState: T = leaveState,
    private readonly changeDetector?: ChangeDetectorRef,
  ) {
    this._currentState = initialState;
  }

  get state(): T {
    return this.currentState;
  }

  enter(): T {

    const startingState = this.currentState;

    const alreadyInEnterState = this.currentState === this.enterState;

    if (!alreadyInEnterState) {

      if (this.enterDelayInMs === 0) {

        this.currentState = this.enterState;

      } else {

        if (!this.enterStateTimer) {

          this.enterStateTimer =
            setTimeout(
              () => this.currentState = this.enterState,
              this.enterDelayInMs
            );
        }
      }
    }

    clearTimeout(this.leaveStateTimer);
    this.leaveStateTimer = undefined;

    this.leaveStateTimer =
      setTimeout(
        () => this.leave(),
        alreadyInEnterState
          ? this.leaveDelayInMs
          : this.leaveDelayInMs + this.enterDelayInMs
      );

    return startingState;
  }

  leave(): T {

    clearTimeout(this.enterStateTimer);
    this.enterStateTimer = undefined;

    clearTimeout(this.leaveStateTimer);
    this.leaveStateTimer = undefined;

    const startingState = this.currentState;

    this.currentState = this.leaveState;

    return startingState;
  }

}
